import * as React from 'react';
import { useSelector } from 'react-redux';

import { useHiddenMessagePhones } from './useHiddenMessagePhones';
import { useOutcomingMessageStyle } from './useOutcomingMessageStyle';
import { currentOpenChatIDSelector } from '../../../selectors';
import { TMessage, TOutcomingStatus } from '../../../types/messages';
import { trackHiddenMessagePhoneClick } from '../tracking';

interface IUseMessageTextProps {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
}

export const useMessageText = ({ message, messageId }: IUseMessageTextProps) => {
  const { userId, communicationId, offers, message: text } = message;
  const chatId = useSelector(currentOpenChatIDSelector) || '';
  const offer = offers?.[0];

  const isOutcoming = useOutcomingMessageStyle(message.isOutcoming, userId);

  const hiddenMessagePhonesClick = React.useCallback(() => {
    trackHiddenMessagePhoneClick({
      chatId,
      messageId,
      offerId: offer?.realtyOfferId,
      communicationId,
    });
  }, [chatId, communicationId, messageId, offer?.realtyOfferId]);

  const { replacePhoneNumbers } = useHiddenMessagePhones({
    messageUserId: userId,
    isOutcoming,
    onClick: hiddenMessagePhonesClick,
  });

  return React.useMemo(() => {
    const trimmedText = text?.trim();

    if (!trimmedText) {
      return null;
    }

    return trimmedText.split('\n').map((item, key) => (
      <span key={`text-${key}`}>
        {replacePhoneNumbers(item)}
        <br />
      </span>
    ));
  }, [replacePhoneNumbers, text]);
};
